import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

import 'leaflet/dist/leaflet.css';

import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

L.Icon.Default.mergeOptions({ iconRetinaUrl, iconUrl, shadowUrl });

interface SchoolPin {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
  adminUrl: string;
  stats: {
    users: number;
    recentUsers: number;
    postings: number;
    recentPostings: number;
    activePostings: number;
  };
}

interface SchoolsMapProps {
  schools: SchoolPin[];
}

const mapboxTileUrl = `https://api.mapbox.com/styles/v1/mapbox/streets-v12/tiles/{z}/{x}/{y}@2x?access_token=${ENV.MAPBOX_ACCESS_TOKEN}`;
const mapboxAttribution = `
  &copy; <a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a>
  &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors`;

export function SchoolsMap({ schools }: SchoolsMapProps) {
  const bounds =
    schools.length > 0 ? L.latLngBounds(schools.map((s) => [s.latitude, s.longitude] as L.LatLngTuple)) : undefined;

  return (
    <MapContainer
      bounds={bounds}
      boundsOptions={{ padding: [30, 30] }}
      center={bounds ? undefined : [39.8, -98.6]}
      zoom={bounds ? undefined : 4}
      style={{ height: '75vh', width: '100%' }}
      scrollWheelZoom={true}
    >
      <TileLayer attribution={mapboxAttribution} url={mapboxTileUrl} tileSize={512} zoomOffset={-1} />
      {schools.map((school) => (
        <Marker key={school.id} position={[school.latitude, school.longitude]}>
          <Popup>
            <a href={school.adminUrl}>
              <strong>{school.name}</strong>
            </a>
            <table className="mt-2">
              <tbody>
                <tr>
                  <td className="pe-3">Users</td>
                  <td>
                    {school.stats.users} ({school.stats.recentUsers} new)
                  </td>
                </tr>
                <tr>
                  <td className="pe-3">Postings</td>
                  <td>
                    {school.stats.postings} ({school.stats.recentPostings} new)
                  </td>
                </tr>
                <tr>
                  <td className="pe-3">Active postings</td>
                  <td>{school.stats.activePostings}</td>
                </tr>
              </tbody>
            </table>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
